module.exports = __webpack_public_path__ + "img/jclogo.50608bf7.png";